/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EvaluationSubjectForBookOptionsInterface, EvaluationSubjectInterface } from '../../+models';
import {
  AddEvaluationSubjectResponseInterface,
  UpdateEvaluationSubjectResponseInterface,
} from '../../evaluation-subject';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class EvaluationSubjectApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'EvaluationSubjects');
  }

  getEvaluationSubjectsForBook(
    bookId: number,
    options?: EvaluationSubjectForBookOptionsInterface
  ): Observable<EvaluationSubjectInterface[]> {
    const path = `evaluation-subject/${bookId}`;
    const params = options
      ? this._getHttpParams({
          includeContentFlag: options.includeContentFlag,
        })
      : undefined;
    return this.get(path, params);
  }

  addEvaluationSubject(evaluationSubject): Observable<AddEvaluationSubjectResponseInterface> {
    const path = `create`;
    return this.put(path, undefined, evaluationSubject);
  }

  updateEvaluationSubject(
    evaluationSubjectId: number,
    changes: Partial<EvaluationSubjectInterface>
  ): Observable<UpdateEvaluationSubjectResponseInterface> {
    const path = `${evaluationSubjectId}/update`;
    return this.patch(path, undefined, changes);
  }

  deleteEvaluationSubject(evaluationSubjectId: number): Observable<boolean> {
    const path = `${evaluationSubjectId}/remove`;
    return this.delete(path);
  }
}
